<template>
    <div class="wizard-forms vrm-dess-wizard__grid">
        <div class="row ">
            <div class="col-md-10 col-md-offset-1">
                <h2>{{ $t('firmware-library.files') }}</h2>
                <p>
                    {{
                        $t('firmware-library.filesDescription', {
                            i18nFallback:
                                'You can upload multiple firmware files within the supported file format: .dup, .bup, .xup, .vup, .vff, .evcsup',
                        })
                    }}
                </p>
                <div v-for="(file, idx) in files" :key="file.name + idx" class="vrm-form__file">
                    <div>
                        <span class="sg-vrm-icon_044_file-16px" />
                        {{ file.name }}
                    </div>
                    <i class="sg-vrm-icon_055_cross-16px" @click="removeFile(file)" />
                </div>
                <vrm-file-picker-field
                    v-if="!isEdit"
                    :accepted-file-types="[
                        '.dup',
                        '.bup',
                        '.xup',
                        '.vup',
                        '.vff',
                        '.evcsup',
                        '.info',
                    ]"
                    :multiple="true"
                    :show-file-names="false"
                    class="sg-element"
                    placeholder="File Upload"
                    :error="error"
                    @change="onFileUpload"
                ></vrm-file-picker-field>
            </div>
        </div>
    </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import {
    NEW_RELEASE,
    CREATE_NEW_RELEASE_FORM_FIELDS,
} from '@/vue/store/modules/create-new-release-form';
import VrmFilePickerField from '@/vue/components/forms/VrmFilePickerField.vue';

@Component({
    components: { VrmFilePickerField },
})
export default class Files extends Vue {
    @Prop()
    initialValues;
    @Prop({ type: Boolean, default: false })
    isEdit;

    creating = false;
    error = null;

    get files() {
        return this.$store.state.createNewReleaseForm.files;
    }

    set files(value) {
        this.compareAndEmitEdit(value);
        this.$store.commit(NEW_RELEASE.SET_FORM_FIELD, {
            value: value,
            key: CREATE_NEW_RELEASE_FORM_FIELDS.files,
        });
    }

    created() {
        this.creating = !this.files.length;
    }

    compareAndEmitEdit(newValue) {
        if (this.creating) {
            this.$emit('creating', true);
        }
        this.$emit('change', {
            hasChange:
                newValue.length !== this.initialValues['files'] ||
                newValue.some(file => !this.initialValues['files'].includes(file)),
            formName: 'files',
        });
    }

    onFileUpload(files) {
        if (
            files.filter(newFile => this.files.map(file => file.name).includes(newFile.name))
                .length > 0
        ) {
            files = files.filter(value => this.files.includes(value));
            this.error = this.$t('firmware-library.repeatedFilesError', {
                i18nFallback:
                    'At least one of the selected files has already been added to this release',
            });
        } else {
            this.error = null;
        }
        this.files = this.files.concat(files);
    }

    removeFile(fileName) {
        this.files = this.files.filter(file => file.name !== fileName.name);
    }
}
</script>
